import React, { useContext } from 'react'
import { Box, Button, Flex, Text } from 'rebass/styled-components'
import { ThemeContext } from 'styled-components'
import { Input, Textarea, Label } from '@rebass/forms/styled-components'
import { Checkbox } from '@rebass/forms'
// Styled components checkbox doesn't work so utilising ThemeContext to style standard rebass component.
import { useForm } from 'react-hook-form';


const ConsignmentForm = ({ sendMail }) => {
    const url = typeof window !== 'undefined' ? window.location.href : 'Referring URL not available'
    const { register, handleSubmit, formState: { errors }} = useForm();
    const theme = useContext(ThemeContext);


    const onSubmit = (data) => sendMail(data, 'contact_form');
    return (
        <Box
            pl={['sm', 'sm', 'md']}
            pr={['sm', 'sm', 'md']}
            pt={['lg', 'lg', 'lg', 'lg', 'xl']}
        >
            <Flex
                alignItems="flex-start"
                alignContent="flex-start"
                onSubmit={handleSubmit(onSubmit)}
                as="form"
                autocomplete="on"
                flexDirection={['column', 'column', 'column', 'row']}
                variant="container"
                name="consignmentFormRef" // This is for ScrollTo to work.
            >
                <Input type="hidden" name="subject" value="New Consignment Enquiry" {...register('subject')} />
                <Input type="hidden" name="referrer" value={url} {...register('referrer')} />
                <Box
                    mr={['0', '0', '0', 'md']}
                    flexGrow="1"
                    flexBasis={['100%', '100%', '100%', '50%']}
                >
                    <Input autoComplete="name" type="text" name="from_name" placeholder="Name" {...register('from_name', { required: true })} />
                    {errors.from_name && <span className="errorMessage">Please enter your name.</span>}
                    <Input autoComplete="email" type="email" name="reply_to" placeholder="Email" {...register('reply_to', { required: true })} />
                    {errors.reply_to && <span className="errorMessage">Please provide a valid email address.</span>}
                    <Input autoComplete="tel" type="tel" name="phone" placeholder="Phone" {...register('phone', { required: true })} />
                    {errors.phone && <span className="errorMessage">Please provide a contact number.</span>}
                    <Input type="text" name="manufacturer" placeholder="Vehicle manufacturer" {...register('manufacturer')} />
                    <Input type="text" name="model" placeholder="Vehicle model" {...register('model')} />
                </Box>
                <Box
                    mt={['md', 'md', 'md', '0']}
                    ml={['0', '0', '0', 'md']}
                    flexGrow="1"
                    flexBasis={['100%', '100%', '100%', '50%']}
                >
                    <Textarea
                        name="message"
                        placeholder="Comments"
                        type="textarea" {...register('message', { required: true })}
                        sx={{
                            borderColor: 'aquaMedium',
                            overflow: 'auto',
                            marginTop: '0',
                            minHeight: '300px',
                            resize: 'vertical',
                        }}
                    />
                    {errors.message && <span className="errorMessage">Please write a brief message so we can respond as swiftly as possible.</span>}
                    <Flex
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Button
                            aria-pressed="false"
                            enterKeyHint="done"
                            mr="auto"
                            mt="md"
                            type="submit"
                            variant="primary"
                        >Submit</Button>
                        <Box
                            mt="md">
                            <Label>
                                <Flex
                                    alignItems="center"
                                    justifyContent="flex-end"

                                >
                                    <Text
                                        mx="xs"
                                    >Add me to the Newsletter</Text>
                                </Flex>
                                <Flex>
                                    <Checkbox
                                        id="newsletter_consent"
                                        name="newsletter_consent" {...register('newsletter_consent', { required: false })}
                                        mr="0"
                                        sx={{
                                            'input:checked ~ &': {
                                                color: theme.colors.aquaDark,
                                            },
                                            color: theme.colors.aquaDark,
                                        }
                                        }
                                    />
                                </Flex>
                            </Label>
                        </Box>
                    </Flex>
                </Box>
            </Flex>
        </Box>
    )
}

export default ConsignmentForm
